import script from "./CreatorChatSearchOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorChatSearchOverlay.vue?vue&type=script&setup=true&lang=js"

import "./CreatorChatSearchOverlay.vue?vue&type=style&index=0&id=7d2ffce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2ffce4"]])

export default __exports__